import React, { useState, useContext, useRef, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import {
  TextInput,
  DateInput,
  CustomSwitch,
  LocalizationAutocomplete,
  FloatInput,
  IntInput,
} from "components/Input/Index.js";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import SmallButton from "components/CustomButtons/Button.js";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { mandates } from "variables/markets";
import { memberorderStatusDataAdmin } from "variables/lists/markets";
import { putMarketMembershipOrder, getMarketMembership, getAccountContracts, getAccountDsos } from "services/ConfigServices";
import { MarketsContext } from "context/MarketsContext";
import { memberorder } from "variables/markets";
import { meters } from "variables/markets";
import { metersStatusData } from "variables/lists/markets";
import { compte } from "variables/patrimoine.js";
import { statusData, divisionUnitData } from "variables/lists/patrimoine";
import { site, meter as metertext } from "variables/patrimoine.js";
import { datedistributionData } from "variables/lists/meters";
import ImageList from "@mui/material/ImageList";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import AddGroupDialog from "components/Patrimoine/Group/AddGroupDialog";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import uuid from "react-uuid";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

const ParametersTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
  margin-top: 12px;
`;
const ParametersNote = styled.div`
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
  margin-top: 12px;
`;
const TreeHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles2 = makeStyles(styles);

function EditMeterAccountDialog(props) {
  const { closeModal, refetch, serviceorder, market } = props;
  const appContext = useContext(AdvancedSearchContext);
  const {groupAccountListById, groupTypeListById } = appContext;

  const [buttonDisabled, setButtonDisabled] = useState(false);
  const energy = market.parameters.general.energy;

  const [accountid, setAccountid] = useState();

  //Market Meter
  const [marketstatus, setMarketStatus] = useState("pending");
  const [dateend, setDateend] = useState("");
  //Account meter

  const [meternumber, setMeternumber] = useState(serviceorder.parameters.pdl || "");
  const [status, setStatus] = useState("off");

  const [monthlyconsumption, setMonthlyconsumption] = useState(false);
  const [dailyconsumption, setDailyconsumption] = useState(false);
  const [loadcurve, setloadcurve] = useState(false);
  const [contractualdata, setContractualdata] = useState(false);
  const [utilitydata, setUtilitydata] = useState(false);
;

  //Market Meter
  const handleMarketStatusChange = (event) => { setMarketStatus(event.target.value); };
  const handleDateendChange = (event) => { setDateend(event.target.value); };

  //Account meter
  const handleMeternumberChange = (e) => {
    setMeternumber(e.target.value);
  };
  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };
  const handleMonthlyconsumptionChange = (e) => {
    setMonthlyconsumption(!monthlyconsumption);
  };
  const handleDailyconsumptionChange = (e) => {
    setDailyconsumption(!dailyconsumption);
  };
  const handleLoadcurveChange = (e) => {
    setloadcurve(!loadcurve);
  };
  const handleContractualdataChange = (e) => {
    setContractualdata(!contractualdata);
  };
  const handleUtilitydataChange = (e) => {
    setUtilitydata(!utilitydata);
  };

  const handleSubmit = (event) => {
    validateServiceOrderexectutionFunction(event);
  };


  const validateServiceOrderexectutionFunction = async (event) => {
    let idSelected = serviceorder.id;
    let url = putMarketMembershipOrder(idSelected, market.id, 'accountmeter');
    await axios
      .put(url,
        {
          serviceorderparameters:
          {
            ...serviceorder.parameters,
            status: 'executed',
          },
          metermarketparameters: {
            marketmeterid: serviceorder.parameters.marketmeterid,
            status: marketstatus,
            dateend,
            meternumber,
          },
          accountmeterparameters: {
            id : serviceorder.parameters.marketmeteraccountmeterid,
            details: {
              status,
              monthlyconsumption,
              dailyconsumption,
              loadcurve,
              contractualdata,
              utilitydata,
            },
          },
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },

        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `L'ordre de service a été validé`
          );
          closeModal();
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();
  const classes2 = useStyles2();
  return (
    <>
      <form className={classes.root}>
        <GridContainer>

          <GridItem xs={12} sm={12} md={12} lg={12}>
            <ParametersTitle>{memberorder.marketparameters}</ParametersTitle>
            <div>
              <TextInput
                isRequired
                inputTitle={memberorder.marketmembershipname}
                textInput={serviceorder.parameters.marketmembershipname + " (" + serviceorder.parameters.marketmembershipnumber + ")"}
                disabled
              />
            </div>
            <div>
              <CustomSelect
                isRequired
                inputTitle={meters.status}
                selectValue={marketstatus}
                handleSelectValueChange={handleMarketStatusChange}
                data={metersStatusData}
              />
            </div>
            <div>
              <DateInput
                inputTitle={meters.dateend}
                dateInput={dateend}
                handleDateInputChange={handleDateendChange}
              />
            </div>
            <ParametersTitle>{memberorder.generalparameters}</ParametersTitle>
            <div>
              <TextInput
                isRequired
                inputTitle={compte.energy[energy].meters.meternumber}
                textInput={meternumber}
                handleTextInputChange={handleMeternumberChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={compte.energy[energy].meters.status}
                selectValue={status}
                handleSelectValueChange={handleStatusChange}
                data={statusData}
              />
            </div>

            <ParametersTitle>{memberorder.trdeactivationparameters}</ParametersTitle>
            <div>
              <CustomSwitch
                inputTitle={
                  compte.energy[energy].meters.monthlyconsumption
                }
                checkedState={monthlyconsumption}
                handleSwitchChange={handleMonthlyconsumptionChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={compte.energy[energy].meters.dailyconsumption}
                checkedState={dailyconsumption}
                handleSwitchChange={handleDailyconsumptionChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={compte.energy[energy].meters.loadcurve}
                checkedState={loadcurve}
                handleSwitchChange={handleLoadcurveChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={compte.energy[energy].meters.contractualdata}
                checkedState={contractualdata}
                handleSwitchChange={handleContractualdataChange}
              />
            </div>
            <div>
              <CustomSwitch
                inputTitle={compte.energy[energy].meters.utilitydata}
                checkedState={utilitydata}
                handleSwitchChange={handleUtilitydataChange}
              />
            </div>

            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              {memberorder.validate}
            </Button>
          </GridItem>
        </GridContainer>

      </form>
    </>
  );
}

export default EditMeterAccountDialog;
